import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from '../../config/i18n';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';
import RecordList from '../../components/record/RecordList';

export class RecordListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        query: '',
        page: 0,
      },
      isFirstPage: true,
    };
  }

  componentDidMount = async () => {
    const {
      actions: {
        fetchPatientList,
        createDangerAlert,
      },
    } = this.props;
    const result = await fetchPatientList(this.state.filter);
    if (result !== true) {
      createDangerAlert(result.message);
    }
  }

  render() {
    const { router } = this.props;
    const {
      patientList,
      isPatientListLoading,
    } = this.props.reducers.patient;

    return (
      <div className="col-md-12">
        {
          /*
            the search bar and pagination are not really working now,
            since we don't have page information along with patient list,
            if you don't want to show them, just hide them
          */
        }
        <h1>
          {i18n.t('recordList')}
        </h1>
        <p className="lead">
          {i18n.t('browseChooseMedicalRecord')}
        </p>
        <hr />
        <div>
          <RecordList
            recordData={patientList}
            isLoading={isPatientListLoading}
            router={router}
          />
        </div>
      </div>
    );
  }
}

RecordListContainer.propTypes = {
  actions: PropTypes.shape({
    fetchPatientList: PropTypes.func.isRequired,
  }).isRequired,
  reducers: PropTypes.shape({
    patient: PropTypes.shape({
      patientList: PropTypes.array,
      isPatientListLoading: PropTypes.bool,
    }),
  }).isRequired,
  router: PropTypes.object.isRequired,
};

export default connectActionsAndReducers(RecordListContainer);



// WEBPACK FOOTER //
// ./src/containers/record/RecordListContainer.js